import { TextBox } from 'devextreme-react';
import { useEffect, useRef } from 'react';
import { usePage } from '..';

export const SearchBar = ({ isInForm }) => {
  const searchRef = useRef();
  const { searchEnabled, searchValue, setSearchValue } = usePage();

  useEffect(() => {
    if (searchEnabled) searchRef.current.instance.focus();
  }, [searchEnabled]);

  return (
    <TextBox
      ref={searchRef}
      mode="search"
      value={searchValue}
      onInput={(e) => {
        const { text } = searchRef.current.instance.option();
        setSearchValue(text);
      }}
      showClearButton={true}
      visible={!Boolean(isInForm) && searchEnabled}
      style={{ flexGrow: 1 }}
      placeholder="Buscar"
    />
  );
};
